var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandicon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9999 25.9964C52.0013 31.1397 50.4774 36.168 47.621 40.4452C44.7646 44.7224 40.7038 48.0565 35.9524 50.0258C31.201 51.995 25.9723 52.511 20.9276 51.5085C15.8829 50.506 11.2489 48.0299 7.61145 44.3935C3.97405 40.7572 1.49673 36.1238 0.49278 31.0794C-0.511165 26.035 0.00336961 20.8061 1.97131 16.0542C3.93925 11.3022 7.2722 7.24054 11.5486 4.38291C15.8251 1.52527 20.8529 2.00767e-07 25.9962 0C32.8916 -2.69155e-07 39.5046 2.73866 44.381 7.61372C49.2574 12.4888 51.9979 19.101 51.9999 25.9964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7968 43.1069H28.4812V26.396H33.1385L33.6325 20.8014H28.4812V17.6118C28.4812 16.2968 28.75 15.7736 30.0215 15.7736H33.6543V9.96115H29.0116C24.0492 9.96115 21.8114 12.1408 21.8114 16.3331V20.7942H18.3384V26.4614H21.7968V43.0996V43.1069Z",
    fill: "url(#paint0_linear_148_14569)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_14569",
    x1: 18.3384,
    y1: 26.534,
    x2: 33.6325,
    y2: 26.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D4390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076BAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandicon01);
export default __webpack_public_path__ + "static/media/brandicon01.15de8f7d05ea70e6b8c83d1a98cb17f2.svg";
export { ForwardRef as ReactComponent };